import { Flex, Stack } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { innerLinks } from '@/utils/constants/inner-links';
import ContactForm from './ContactForm';
import { H1 } from '@/components/Headings';
import { TextDefault } from '@/components/Texts';
import { colors } from '@/styles/theme/colors';
import { ArrowUpRightSVG } from '@/assets/svgs';
import BaseButton from '@/components/BaseButton';

const GetInTouch = () => {
  const { t } = useTranslation('main');

  return (
    <Flex
      direction={{ base: 'column', lg: 'row' }}
      gap={8}
      justify={{ base: 'center', lg: 'space-between' }}
      align={{ base: 'center', lg: 'start' }}
    >
      <Stack
        textAlign={{ base: 'center', lg: 'start' }}
        align={{ base: 'center', lg: 'start' }}
        color={colors.diment.darkBlue}
        maxW={'lg'}
        flex={1}
        spacing={16}
      >
        <Stack spacing={0}>
          <H1>{t('contact-us.get-in-touch.heading')}</H1>
          <TextDefault fontWeight={500}>
            {t('contact-us.get-in-touch.description')}
          </TextDefault>
        </Stack>
        <Stack
          align={{ base: 'center', lg: 'start' }}
          borderRadius={'2xl'}
          spacing={4}
        >
          <TextDefault fontWeight={500} fontSize={'lg'}>
            {t('contact-us.get-in-touch.help')}
          </TextDefault>

          <Link style={{ width: '100%', maxWidth: 200 }} href={innerLinks.help}>
            <BaseButton
              w={'full'}
              maxW={200}
              rounded={'none'}
              bg={colors.diment.darkBlue}
            >
              <Flex align='center' justify='center' gap='2' fontWeight={500}>
                <TextDefault fontWeight={400}>
                  {t('contact-us.get-in-touch.contact-support')}
                </TextDefault>
                <ArrowUpRightSVG />
              </Flex>
            </BaseButton>
          </Link>
        </Stack>
      </Stack>
      <ContactForm />
    </Flex>
  );
};

export default GetInTouch;
